import axios from "axios";
import { SERVER_URL } from "config/index";
import store from "../redux/store";

const request = axios.create({
  baseURL: SERVER_URL,
  timeout: 1000000,
});
let requests = [];

request.interceptors.request.use(
  (config) => {
    if (store.getState().user?.token) {
      config.headers.Authorization = `token ${store.getState().user?.token}`;
    }
    requests.push(config);
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default request;
